<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="商户类型:">
        <el-select
          size="small"
          v-model="formInline.agentType"
          placeholder="全部"
        >
          <el-option
            v-for="(val, index) in merchantTypeList"
            :label="val.label"
            :value="val.value"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商户:">
        <el-select
          size="small"
          v-model="formInline.merchantName"
          filterable
          allow-create
          default-first-option
          placeholder="请选择或输入商户名称"
          @blur="selectMerchantNameBlur"
        >
          <el-option
            v-for="(val, index) in merchantList"
            :label="val"
            :value="val"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="服务商:">
        <el-select
          size="small"
          v-model="formInline.disCompanyName"
          filterable
          allow-create
          default-first-option
          placeholder="请选择或输入服务商名称"
          @blur="selectDisCompanyBlur"
        >
          <el-option
            v-for="(val, index) in disCompanyList"
            :label="val.label"
            :value="val.label"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="时间范围: ">
        <el-date-picker
          size="small"
          v-model="formInline.date"
          type="daterange"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">搜索</el-button>
        <el-button size="small" @click="reset">清空</el-button>
      </el-form-item>
    </el-form>

    <div class="dashboard-container">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="card-wrapper">
            <el-card class="box-card">
              <div slot="header" class="clearfix header-title">
                <span>商户</span>
              </div>
              <div class="merchants">
                <span class="count">{{ partnerMerchantNum }}</span>
                <p><span>已合作</span></p>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="card-wrapper">
            <el-card class="box-card">
              <div slot="header" class="clearfix header-title">
                <span>商户累计充值（元）</span>
              </div>
              <div class="total-disbursement">
                <span class="amount">{{ cumulativeRecharge }}</span>
                <p><span>已充值</span></p>
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="card-wrapper">
            <el-card class="box-card">
              <div slot="header" class="clearfix header-title">
                <span>商户累计发放（元）</span>
              </div>

              <div class="service-fees">
                <div class="fee-item">
                  <span class="zero-work-costs">{{ serviceFee }}</span>
                  <p><span>灵工费用</span></p>
                </div>

                <div class="fee-item">
                  <span class="service-costs">{{ managementFee }}</span>
                  <p><span>管理费</span></p>
                </div>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  getSalesStatisticsData,
  getSalesMerchantName,
  getDisCompanyNames,
} from "../../api/userMG";
export default {
  name: "index-sales",
  components: {
    // "notice-list": noticeList,
  },

  data() {
    return {
      partnerMerchantNum: 0,
      serviceFee: "0.00",
      managementFee: "0.00",
      cumulativeRecharge: "0.00",
      merchantList: [],
      disCompanyList: [],
      merchantTypeList: [
        {
          label: "普通商户",
          value: 1,
        },
        {
          label: "代理商户",
          value: 2,
        },
      ],
      formInline: {
        disCompanyName: "",
        merchantName: "",
        startDate: "",
        endDate: "",
        agentType: "",
        date: [],
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    };
  },

  created() {
    getSalesMerchantName({
      page: 1,
      pageSize: 9999,
    })
      .then((res) => {
        if (res.msg == "success") {
          this.merchantList = res.data.items;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      })
      .catch((err) => {});

    // 服务商
    getDisCompanyNames({
      page: 1,
      pageSize: 9999,
      type: 2,
    })
      .then((res) => {
        if (res.msg == "success") {
          this.disCompanyList = res.data;
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      })
      .catch((err) => {});
  },

  mounted() {
    // 处理日期范围
    if (this.formInline.date && this.formInline.date.length === 2) {
      this.formInline.startDate = this.formInline.date[0] || "";
      this.formInline.endDate = this.formInline.date[1] || "";
    } else {
      this.formInline.startDate = "";
      this.formInline.endDate = "";
    }
    this.getdata(this.formInline);
  },

  watch: {
    "formInline.agentType": function (newVal) {
      let params = {
        agentType: newVal,
        page: 1,
        pageSize: 9999,
      };

      getSalesMerchantName(params)
        .then((res) => {
          if (res.msg == "success") {
            this.merchantList = res.data.items;
            this.formInline.merchantName = "";
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
  },

  methods: {
    // 首页数据看板跳转
    jumpClick(path) {
      console.log(path);
      this.$router.push({ path: path });
    },

    // 跳转页面
    jumpToPage(path, origin) {
      this.$router.push({ path: path });
    },

    // 跳转批次数据准备页面
    jumpToBatch() {
      if (this.batchType) {
        this.$router.push({ name: this.batchType });
      }
    },

    // 签署合同倒计时
    countDown() {
      let that = this;
      let t = setInterval(function () {
        if (that.contractCodeTimer > 1) {
          that.contractCodeTimer--;
          that.contractCodeText = "(" + that.contractCodeTimer + "s)";
          that.btnDisabled = false;
        } else {
          clearInterval(t);
          that.contractCodeTimer = that.contractCodeTimer;
          that.contractCodeText = "";
          that.btnDisabled = true;
        }
      }, 1000);
    },

    backChange() {
      this.$router.push({
        path: "/indexMer",
      });
    },
    getdata(formInline) {
      let params = {
        merchantName: formInline.merchantName,
        disCompanyName: formInline.disCompanyName,
        startDate: formInline.startDate,
        endDate: formInline.endDate,
        agentType: formInline.agentType,
      };
      getSalesStatisticsData(params)
        .then((res) => {
          if (res.msg == "success") {
            this.partnerMerchantNum = res.data.partnerMerchantNum;
            this.serviceFee = res.data.amountReceived;
            this.managementFee = res.data.managementFee;
            this.cumulativeRecharge = res.data.cumulativeRecharge;
          } else {
            this.$message({
              type: "error",
              message: res.msg,
            });
          }
        })
        .catch((err) => {});
    },
    search() {
      // 处理日期范围
      if (this.formInline.date && this.formInline.date.length === 2) {
        this.formInline.startDate = this.formInline.date[0] || "";
        this.formInline.endDate = this.formInline.date[1] || "";
      } else {
        this.formInline.startDate = "";
        this.formInline.endDate = "";
      }
      this.getdata(this.formInline);
    },

    reset() {
      (this.formInline = {
        merchantName: "",
        disCompanyName: "",
        startDate: "",
        endDate: "",
        agentType: "",
      }),
        this.getdata(this.formInline);
    },
    selectMerchantNameBlur(e) {
      this.formInline.merchantName = e.target.value;
    },
    selectDisCompanyBlur(e) {
      this.formInline.disCompanyName = e.target.value;
    },
  },

  beforeCreate() {
    // console.log("商户 beforeCreate");
  },

  beforeDestroy() {
    // console.log("商户 beforeDestroy");
  },

  destroyed() {},
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.el-form-item {
  margin-bottom: 20px !important; /* 调整间距 */
}

.box-card {
  min-height: 150px;
  text-align: center;
}

.clearfix::after {
  content: "";
  display: block;
  clear: both;
}

.header-title span {
  font-size: 18px; /* 调整字体大小 */
  font-weight: bold; /* 加粗字体 */
}
.card-wrapper {
  margin-top: 20px; /* 添加上边距 */
}
.task-status,
.service-fees {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.task-status .status-item,
.service-fees .fee-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 20px;
}

.task-status .total-tasks {
  font-size: 24px;
  color: #409eff;
}
.task-status .incomplete-tasks {
  font-size: 24px;
  color: #f56c6c;
}
.task-status .pending-invoice {
  font-size: 24px;
  color: #e6a23c;
}

.task-status .completed-tasks {
  font-size: 24px;
  color: #67c23a;
}

.fee-item .zero-work-costs,
.fee-item .service-costs {
  color: #909399;
  font-size: 24px;
}

.total-disbursement .amount,
.merchants .count {
  color: green;
  font-size: 24px;
}
</style>


// WEBPACK FOOTER //
// src/views/sales/index.vue